import NAV_DATA from '@zola-helpers/client/dist/es/constants/navConstants';

import { MegaMenuNavItem } from './types';

const {
  PRIMARY: { VENDORS },
} = NAV_DATA;

const getVendors = (showVendorInquiriesJewel?: boolean): MegaMenuNavItem => {
  const locationChildren = [
    {
      title: 'New York City',
      path: '/wedding-vendors/search/new-york-ny--wedding-venues',
    },
    {
      title: 'Los Angeles',
      path: '/wedding-vendors/search/los-angeles-ca--wedding-venues',
    },
    {
      title: 'Chicago',
      path: '/wedding-vendors/search/chicago-il--wedding-venues',
    },
    {
      title: 'Philadelphia',
      path: '/wedding-vendors/search/philadelphia-pa--wedding-venues',
    },
    {
      title: 'View All Locations',
      path: '/wedding-vendors/search/wedding-venues',
    },
  ];

  const inspirationChildren = [
    {
      title: 'Beach',
      path: '/inspiration/real-weddings/beaches-waterfronts',
    },
    {
      title: 'Rustic',
      path: '/inspiration/real-weddings/rustic',
    },
    {
      title: 'Traditional',
      path: '/inspiration/real-weddings/traditional',
    },
    {
      title: 'Bohemian',
      path: '/inspiration/real-weddings/boho',
    },
    {
      title: 'Vintage',
      path: '/inspiration/real-weddings/vintage',
    },
    {
      title: 'View All Styles',
      path: '/inspiration',
    },
  ];

  const exploreChildren = [
    // TODO: Hiding for now; Marketplace team is worried about influx of users and Zola's capacity to support those users
    // {
    //   title: 'Vendor Log In',
    //   path: '/inspire/vendors',
    // },
    {
      title: 'Become A Vendor',
      path: '/wedding-vendors/become-a-vendor',
    },
    {
      title: 'How Much To Tip Wedding Vendors',
      path: '/expert-advice/a-guide-to-tipping-wedding-vendors',
    },
    {
      title: 'Vendor Expert Advice',
      path: '/expert-advice/topic/planning-101/hiring-vendors',
    },
    {
      title: 'Vendor FAQs',
      path: 'https://help.zola.com/hc/en-us/categories/360000467031-Vendor-Listings-Real-Weddings',
    },
  ];

  return {
    title: 'Vendors',
    id: VENDORS,
    path: '/wedding-vendors',
    parent: 'Vendors',
    showJewel: showVendorInquiriesJewel,
    callToAction: {
      path: '/wedding-vendors',
      title: 'Browse Vendors',
      items: [
        'Exceptional vendors for every couple, all pre-screened for you',
        'Personalized recs based on your unique wedding vision',
        'Sleek, simplified experience with ad-free search results',
      ],
    },
    userActionsLinks: [
      {
        title: 'Your Vendor Inquiries',
        path: '/wedding-vendors/inquiries',
      },
      {
        title: 'Your Booked Vendors',
        path: '/wedding-vendors/inquiries/booked',
      },
    ],
    children: [
      {
        headline: 'Our Locations',
        children: locationChildren,
      },
      {
        headline: 'Real Wedding Inspiration',
        children: inspirationChildren,
      },
      {
        headline: 'Learn More',
        borderLeft: true,
        children: exploreChildren,
      },
    ],
  };
};

export default getVendors;
